export function anchorMenu() {
  const anchorMenu = document.querySelector('.block--anchor-menu');
  const sections = document.querySelectorAll('a[href^="#"]');
  let manualClick = false; // Flag to prevent unwanted deactivation

  // Anchor menu click function
  sections.forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        manualClick = true; // Set manualClick flag
        target.scrollIntoView({
          behavior: 'smooth'
        });

        // Remove 'active' class from all elements
        document.querySelectorAll('.block.active').forEach(el => el.classList.remove('active'));
        document.querySelectorAll('.block--anchor-menu a.active').forEach(el => el.classList.remove('active'));

        // Add 'active' class to clicked target and corresponding menu link
        target.classList.add('active');
        this.classList.add('active');

        setTimeout(() => {
          manualClick = false; // Reset flag after scrolling completes
        }, 800); // Adjust timeout based on scroll duration
      }
    });
  });

  // Scroll-based active class detection
  const observer = new IntersectionObserver(
    entries => {
      if (manualClick) return; // Prevent deactivating active class on manual clicks

      entries.forEach(entry => {
        const id = entry.target.getAttribute('id');
        const menuLink = document.querySelector(`.block--anchor-menu a[href="#${id}"]`);

        if (entry.isIntersecting) {
          // Remove active class from all menu links
          document.querySelectorAll('.block--anchor-menu a.active').forEach(el => el.classList.remove('active'));

          if (menuLink) {
            menuLink.classList.add('active');
          }
        }
      });
    },
    {
      rootMargin: "0px 0px -80% 0px", // Adjusted so sections activate earlier
      threshold: 0
    }
  );

  // Observe all sections linked in the menu
  document.querySelectorAll('.block').forEach(section => {
    observer.observe(section);
  });
}
